var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartFlatbedEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 400V432C640 440.801 632.801 448 624 448H541.062C542.85 453.027 544 458.359 544 464C544 490.508 522.51 512 496 512S448 490.508 448 464C448 458.359 449.15 453.027 450.938 448H253.062C254.85 453.027 256 458.359 256 464C256 490.508 234.51 512 208 512S160 490.508 160 464C160 458.359 161.15 453.027 162.938 448H80C71.201 448 64 440.801 64 432V80C64 71.164 56.838 64 48 64H16C7.201 64 0 56.801 0 48V16C0 7.199 7.201 0 16 0H64C99.201 0 128 28.801 128 64V384H624C632.801 384 640 391.199 640 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFlatbedEmpty);
export default __webpack_public_path__ + "static/media/cart-flatbed-empty.732406810463e2031088f3421889f9c2.svg";
export { ForwardRef as ReactComponent };